





















import { Component, Vue } from 'vue-property-decorator';

@Component
export default class DictionaryComponent extends Vue {

    snackbarOpen!: boolean;
    clipboardError!: boolean;

    async copy(text: string) {
        this.clipboardError = false;
        this.snackbarOpen = false;
        try {
            if (!navigator.clipboard) {
                throw 'Clipboard not available!';
            }
            await navigator.clipboard.writeText(text);
        } catch (error) {
            this.clipboardError = true;
        }
        this.snackbarOpen = true;
    }

    private close(evt: MouseEvent) {
        evt.stopPropagation();
        evt.preventDefault();

        this.snackbarOpen = false;
    }

    private data() {
        return {
            snackbarOpen: false,
            clipboardError: false
        }
    }

}
